<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <!-- Filter -->
            <button
              class="btn me-2 add"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <i class="fas fa-filter ms-1"></i>
              فلتر
            </button>
            <div
              class="modal fade"
              tabindex="-1"
              id="filterModal"
              aria-labelledby="filterModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form @submit.prevent="filteredSelectData($event)">
                    <div class="modal-header">
                      <h5 class="modal-title">اعادة تصنيف</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="filter"
                              id="filterOne"
                              :value="true"
                              v-model="filter"
                            />
                            <label class="form-check-label" for="filterOne"
                              >تم حظرهم</label
                            >
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="filter"
                              id="filterTwo"
                              v-model="filter"
                              :value="false"
                            />
                            <label class="form-check-label" for="filterTwo"
                              >لم يتم حظرهم</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn delete"
                        data-bs-dismiss="modal"
                        @click="removeFiltered()"
                      >
                        أعادة تعيين
                      </button>
                      <button type="submit" class="btn add">تنفيذ</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh($event)"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.users.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="fit" scope="col">المستخدم</th>
                  <th scope="col">الاسم</th>
                  <th scope="col">التليفون</th>
                  <th scope="col">البريد الالكتروني</th>
                  <th scope="col">الفصل الدراسى</th>
                  <th style="width: 12%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in this.users" :key="index">
                  <th scope="row">
                    <div class="user__image" v-if="user.photo">
                      <img
                        class="userImg w-100"
                        :src="user.photo"
                        alt="user_photo"
                      />
                    </div>
                    <div class="user__image" v-if="!user.photo">
                      <img
                        class="userImg w-100"
                        src="@/assets/img_avatar.png"
                        alt="user_photo"
                      />
                    </div>
                  </th>
                  <td>{{ user.name }}</td>
                  <td>{{ user.phone }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.grade.title }}</td>

                  <td>
                    <button
                      @click="blockSelectUser(user.user_id)"
                      v-if="!user.is_blocked"
                      class="btn block"
                    >
                      <i class="fa fa-ban ms-1"></i>
                      حظر
                    </button>
                    <button
                      @click="unblockSelectUser(user.user_id)"
                      v-if="user.is_blocked"
                      class="btn block"
                    >
                      <i class="fa fa-ban ms-1"></i>
                      إلغاء الحظر
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav
              class="pagination text-center"
              v-show="this.isShowButton && !this.filteredPagination"
              aria-label="Page navigation "
            >
              <button
                class="btn add"
                @click="this.getNextSelectedData"
                v-if="!this.loadingMore"
              >
                تحميل المزيد
              </button>
              <div v-else>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>
            <nav
              class="pagination text-center"
              v-show="this.filteredPagination && this.isHaveMoreFilterData"
              aria-label="Page navigation "
            >
              <button
                class="btn add"
                @click="this.nextFilterData(this.filter)"
                v-if="!this.loadingMore"
              >
                تحميل المزيد
              </button>
              <div v-else>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>
            <div
              v-show="
                (!this.isloading && !this.users) || this.users.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد مستخدمين حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      // Loading
      isloading: false,
      // Get Categories has Main
      grades: [],
      categories: [],
      // Current Page Name
      currentView: "المستخدمين",
      // Users List
      users: [],
      // User
      file: null,
      user: {
        name: "",
        photo: "",
        phone: "",
        email: "",
        grade: {
          id: "",
          title: "",
        },
        is_blocked: false,
      },
      // Pagination
      loadingMore: false,
      isShowButton: true,
      // Search
      searchResult: [],
      // filter
      filter: "",
      filteredPagination: false,
    };
  },
  components: {},
  methods: {
    ...mapActions("usersModule", [
      // "fetchUsers",
      "blockUser",
      "unblockUser",
      "addToBlockList",
      "removeFromBlockList",
      // Pagination
      "getFirstData",
      "getNextData",
      "changeSorting",
      // Search
      "searchData",
      // Filter
      "filterData",
      "nextFilterData",
    ]),

    // Pagination
    getNextSelectedData() {
      this.getNextData();
    },
    getPrevSelectedData() {
      this.getPrevData();
    },

    // Search
    getDocBySeacrh(e) {
      if (e.target.value == "") {
        this.users = this.getUsers;
      } else {
        setTimeout(() => {
          this.searchData(e.target.value);
          this.users = this.searchResult;
        }, 800);
      }
    },

    // Filter
    async filteredSelectData(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      closeButton.click();
      await this.filterData(this.filter);
      this.users = this.searchResult;
      this.filteredPagination = true;
    },

    removeFiltered() {
      this.users = this.getUsers;
      this.searchResult = [];
      this.filteredPagination = false;
      this.filter = "";
    },

    // Block User
    blockSelectUser(id) {
      this.blockUser(id);
      this.addToBlockList(id);
    },

    // Unblock User
    unblockSelectUser(id) {
      this.unblockUser(id);
      this.removeFromBlockList(id);
    },

    // get Main Categories
    async getMainCategory() {
      this.grades = await this.getCategories.filter(
        (item) => item.main_category === true && item.show_on_register === true
      );
    },
  },
  async created() {
    // if (this.isFirstLoad) await this.fetchUsers();
    if (this.isFirstLoad) await this.getFirstData();
    await this.getMainCategory();
  },
  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("usersModule", [
      "isFirstLoad",
      "isLoading",
      "getUsers",
      // Pagination
      "isLoadingMore",
      "isShowLoadingButton",
      // Filter
      "isHaveMoreFilterData",
      // Search
      "getSearchResult",
    ]),
  },
  mounted() {
    this.users = this.getUsers;
    this.isloading = this.isLoading;
    // Pagination
    this.isShowButton = this.isShowLoadingButton;
    this.loadingMore = this.isLoadingMore;
    // Search
    this.searchResult = this.getSearchResult;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
    getUsers() {
      this.users = this.getUsers;
    },
    // Pagination
    isLoadingMore() {
      this.loadingMore = this.isLoadingMore;
    },
    isShowLoadingButton() {
      this.isShowButton = this.isShowLoadingButton;
    },
    // Search
    getSearchResult() {
      this.searchResult = this.getSearchResult;
    },
  },
};
</script>

<style lang="scss" scoped>
$circl: 50px;
.user__image {
  width: $circl;
}
</style>
